<div class="mc-view-empty soti-scroll-bar" xmlns="http://www.w3.org/1999/html">

    <nav class="navbar navbar-default navbar-fixed-top">
        <div class="container-fluid">
            <ul class="nav navbar-nav navbar-right">
                <li class="logout">
                    <a href="javascript:void(0)" (click)="onLogout()">
                        <i class="fa fa-sign-out fa-fw"></i><span>{{'label_Logout' | xsI18n}}</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class="bar-title">
            <span class="ssp-title">{{'label_SSP' | xsI18n}}</span>
        </div>
    </nav>
    <div class="scroll-gap"></div>
    <div class="banner">
        <div class="icons">
            <i class="fa famc famc-devices fa-2x"></i>
        </div>
        <div class="content">
            <p>
                <span *ngIf="hasDevices">{{'label_EnrollMoreDevices' | xsI18n}}</span>
                <span *ngIf="!hasDevices">{{'label_NoDevicesEnrolled' | xsI18n}}</span>
            </p>
        </div>
    </div>
    <div class="cards">
        <div class="info-box">
            <div class="box-body">
                <p class="title">
                    <span>{{'label_EnrollThisDevice' | xsI18n}}</span>
                </p>
                <p class="text">
                    <span>{{'message_EnrollThisDevice' | xsI18n}}</span>
                </p>
            </div>
            <div class="add-btn-panel">
                <a class="btn btn-link" href="{{enrollmentLink}}" target="_blank">
                    <i class="fa fa-plus"></i>
                    <span>{{'label_AddDevice' | xsI18n}}</span>
                </a>
            </div>
        </div>
        <div class="info-box">
            <div class="box-body">
                <p class="title">
                    <span>{{'label_EnrollOtherDevice' | xsI18n}}</span>
                </p>

                <p class="text">
                    <span>{{'message_EnrollOtherDevice' | xsI18n}}</span>
                </p>

                <div class="enrollment-link-panel">
                    <p class="enrollment-link text">{{enrollmentLink}}</p>
                </div>
            </div>
        </div>

    </div>
</div>